export default __webpack_public_path__ + "static/media/dolfijn2Klein.c080563a.jpg";